import React from 'react';
import {Button, Table, Form, Loader} from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

const fetchCommitteeStaff = (courseImplementationId) => axios.get(`/exams/committee/staff/${courseImplementationId}`);
const fetchStaff = () => axios.post(`/employees/by-key/professor`, { });

const NoDataMessage = () => <p>Nema uposlenika.</p>;

export default class CommitteeExamStaff extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            courseStaff: [],
            staffArray: [],
            committeeStaff:[],
            members:[],
            head:'',
            reserveMember:'',
            loading: true
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.addStaff = this.addStaff.bind(this);
        this.fetchStaff = this.fetchStaff.bind(this);
        this.removeStaff = this.removeStaff.bind(this);
    }
    componentDidMount() {
      this.fetchStaff();
    }

    fetchStaff(){
      axios.all([fetchStaff(), fetchCommitteeStaff(this.props.gradedActivityId)])
          .then(axios.spread((staffRes, committeeRes) => {
              const courseStaff = staffRes.data.map(el => ({
                  ...el, text: el.firstName + ' ' + el.lastName, value: el.id, key: el.id
              }));

              this.setState({
                  courseStaff,
                  committeeStaff: committeeRes.data,
                  loading: false
              });

          }))
          .catch(err => {
              this.setState({ error: true });
              console.log('Failed to fetch data...');
          });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    addStaff(){
      const staffArray = this.state.staffArray;
      axios.post(`exams/add-staff/${this.props.gradedActivityId}`,  [...staffArray ])
          .then(res => {
            toast('Uspješno ste dodali nastavno osoblje na ispit.');
            this.fetchStaff();
          })
          .catch(err => {
              toast('Došlo je greške! Nastavno osoblje nije dodano na ispit.');
          });
    }

    removeStaff(id){
      let list = [id];
      axios.delete('exams/remove-staff', { data:list })
          .then(res => {
            toast('Uspješno ste uklonili nastavno osoblje sa ispita.');
            this.fetchStaff();
          })
          .catch(err => {
              toast('Došlo je greške! Nastavno osoblje nije uklonjeno sa ispita.');
          });
    }



    render() {
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>
                {this.state.committeeStaff ?

                    <Table celled selectable compact>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>
                                Ime
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                Prezime
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                Uloga
                                </Table.HeaderCell>
                                {/*<Table.HeaderCell colSpan="2">*/}
                                {/*</Table.HeaderCell>*/}
                            </Table.Row>
                        </Table.Header>
                        <Table.Body> {this.state.committeeStaff.map(el =>
                            (<Table.Row >
                                <Table.Cell verticalAlign="middle">
                                    {el.employee.person.firstName}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.employee.person.lastName}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.committeeMemberType.name}
                                </Table.Cell>
                                {/*<Table.Cell textAlign="center" colSpan="2" verticalAlign="middle">*/}
                                    {/*<Button color="red" basic="true" onClick={() => this.removeStaff(el.id)}>Ukloni sa ispita</Button>*/}
                                {/*</Table.Cell>*/}
                            </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                    : <NoDataMessage />
                }

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/Exams/CommitteeExamStaff.js